module.exports = [{"value":"","text":""},{"value":"Kuantan","text":"Kuantan"},{"value":"Melaka","text":"Melaka"},{"value":"Pengerang","text":"Pengerang"},{"value":"Singapore","text":"Singapore"},{"value":"Tg Bin","text":"Tg Bin"},{"value":"Tg Langsat","text":"Tg Langsat"},{"value":"Tg Pelepas","text":"Tg Pelepas"}]


//////////////////
// WEBPACK FOOTER
// ./src/Controls/Select/DataLoadPort.json
// module id = 867
// module chunks = 21